import { makeAutoObservable } from 'mobx'
import type { IChatbotSettings } from '../type'

export class ChatbotInstructions {
  instructions = ''
  handoff_notify_settings: IChatbotSettings['handoff_notify_settings'] | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setInstructions = (value: string) => {
    this.instructions = value
  }

  setHandoffNotifySettings = (value: typeof this.handoff_notify_settings) => {
    this.handoff_notify_settings = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.instructions = settings?.instructions?.value ?? ''
    this.handoff_notify_settings = settings?.handoff_notify_settings ?? null
  }

  toJSON(): Pick<IChatbotSettings, 'instructions' | 'handoff_notify_settings'> {
    return {
      instructions: this.instructions ? { value: this.instructions } : null,
      handoff_notify_settings: this.handoff_notify_settings,
    }
  }
}
